import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import routeConfiguration from '../../../../routeConfiguration';
import { petrol } from '../../../../styles/mui/colors';
import useScreenSize from '../../../../util/hooks/useScreenSize';
import { createResourceLocatorString } from '../../../../util/routes';
import IconBookings from '../../../Icons/IconBookings';
import IconUser from '../../../Icons/IconUser';
import NamedLink from '../../../Links/NamedLink/NamedLink';

const NoBookingsRegisterCTAComponent = () => {
  const intl = useIntl();
  const theme = useTheme();
  const navigate = useNavigate();
  const { isMobile } = useScreenSize();

  const handleButtonClick = useCallback(() => {
    navigate(
      createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}, intl.locale)
    );
  }, [navigate, intl.locale]);

  return (
    <Stack alignItems="center" spacing={2} sx={{ maxWidth: 'sm', width: '100%', mx: 2 }}>
      <Chip label="BOOKINGS" />

      <Typography sx={{ textAlign: 'center' }} variant="h1">
        <FormattedMessage id="InboxPage.noResultsHeading" />
      </Typography>

      <IconBookings sx={{ fontSize: '16em', color: petrol.alpha8 }} />

      <Typography sx={{ textAlign: 'center' }} variant="body1">
        <FormattedMessage id="InboxPage.ctaSubheading" />
      </Typography>

      <Button
        color="primary"
        fullWidth={isMobile}
        onClick={handleButtonClick}
        startIcon={<IconUser />}
        variant="contained"
      >
        <FormattedMessage id="SectionBecomeHost.encourageSignup" />
      </Button>

      <Typography sx={{ display: 'inline' }}>
        <FormattedMessage id="BookmarkPage.loginCTA" />
        <NamedLink
          name="SigninPage"
          style={{ underline: 'none', marginLeft: '0.5em', color: theme.palette.primary.main }}
        >
          <FormattedMessage id="BookmarkPage.loginLink" />
        </NamedLink>
      </Typography>
    </Stack>
  );
};

NoBookingsRegisterCTAComponent.displayName = 'NoBookingsRegisterCTA';
const NoBookingsRegisterCTA = memo(NoBookingsRegisterCTAComponent);

export default NoBookingsRegisterCTA;
